
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class ConfiguracionCamaraService implements RequestCRUD<EstablecimientoEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('SolicitudesService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	update(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	create(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	uploadFile(entry: any): Observable<HttpEvent<any>> {
		const input = new FormData();
		if(entry.file_to_upload != undefined){
			input.append('archivo', entry.file_to_upload, entry.file_to_upload.name);
		}
		input.append('nombre_firma',entry.nombre_firma);
		// tslint:disable-next-line:max-line-length
		const uploadReq = new HttpRequest('POST', `${this.API_URL}/ContenidoCertificadoAdministrador/SubirDocumento/${entry.codigo_camara}/${entry.contenido_certificado_id}`,
			input);
		return this.http
			.request<HttpEvent<any>>(uploadReq).pipe(
				retry(2)
			);
	}
}
